import Navbar from "../components/Navbar";
import AnnounceBar from "../components/AnnounceBar";
import Hero from "../components/Hero";
import About from "../components/About";
import Services from "../components/Services";
import Gallery from "../components/Gallery";
import Compatibility from "../components/Compatibility";
import Products from "../components/Products";
import Stats from "../components/Stats";
import Contact from "../components/Contact";
import Footer from "../components/Footer";
import WhatsAppFab from "../components/WhatsAppFab";

export default function Landing() {
  return (
    <div data-testid="landing-page" className="bg-white text-slate-900">
      <AnnounceBar />
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <Gallery />
        <Compatibility />
        <Products />
        <Stats />
        <Contact />
      </main>
      <Footer />
      <WhatsAppFab />
    </div>
  );
}
